import { dbPost } from '../../../apis/commonApi';

class ExpertAuditController {
  initialState = {
    userNm: '',
    filter: '',
    currentPage: '',
    pageSize: '',
    result: '',
  };

  constructor(
    store,
    modalService,
    validateService,
    [gridRef],
    { valueObj, setValueObj },
    { selectOption, setOption },
    { userInfo, setUserInfo },
    navigate
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.gridRef = gridRef;
    this.valueObj = { ...this.initialState, ...valueObj };
    this.setValueObj = setValueObj;
    this.selectOption = selectOption;
    this.setOption = setOption;
    this.userInfo = userInfo;
    this.setUserInfo = setUserInfo;
    this.navigate = navigate;
  }

  getRole() {
    const role = ['ADMIN', 'EX', 'ME'];
    return role.includes(this.store.authrtId);
  }

  async fnOption() {
    const cd = ['S301'];
    const url = '/expert-audit/status/list.do';
    const param = {
      code: cd,
    };

    let response;

    try {
      response = await dbPost(url, param);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        this.setOption(response[0].s301);
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  // 조회
  async fnSearch() {
    const { userNm, filter } = this.valueObj;
    const url = '/expert-audit/list.do';
    const param = {
      userNm,
      filter,
    };
    this.gridRef.current.doQuery(url, param);
  }

  valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  gridCellDblClick(row, col, rowData) {
    this.navigate('/expert/register/register', {
      state: { rowData: rowData },
    });
  }

  gridCallback = res => {
    const data = res[0];
    if (data) {
      this.setUserInfo(data);
    }
  };

  btnClick() {
    this.navigate('/expert/register/register', {
      state: { rowData: this.userInfo },
    });
  }
}

export default ExpertAuditController;
